import NestedTypes from "backbone.nestedtypes";

export default NestedTypes.Model.extend({
    defaults: {
        id: String,
        name: String,
        group: String, // input, output, processing, enrichment
        iconClass: String,
        componentID: String,
        componentType: String, //source, target, window...
        isVisible: true,
        isEnabled: false,
        tooltip: String,
        version: String,
        category: String // Not always exist
    }
});
